import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ChargeAppLogo from '../../static/chargesk.webp'

const useStyles = makeStyles((theme) => ({
    appBanner: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #e0e0e0',
        position: 'relative',
        gap: '12px',
    },
    closeBtn: {
        border: 'none',
        background: 'none',
        fontSize: '22px',
        color: '#999',
        cursor: 'pointer',
        padding: '0 4px',
        lineHeight: 1,
    },
    appIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        objectFit: 'cover'
    },
    textContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        '& strong': {
            fontSize: '14px',
            color: '#000',
        },
        '& span': {
            fontSize: '12px',
            color: '#666',
        }
    },
    actionBtn: {
        backgroundColor: '#000',
        color: '#fff !important',
        padding: '8px 14px',
        borderRadius: '4px',
        textDecoration: 'none !important',
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        border: 'none'
    }
}));

const AppBanner = () => {
    const classes = useStyles();
    const location = useLocation();
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const isAuthenticated = useSelector((state: any) => state.user?.login.value?.isLoggedIn);

    useEffect(() => {
        const bannerHidden = localStorage.getItem('appBannerHidden');
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        const allowedPaths = ['/', '/login', '/register'];
        const isAllowedPath = allowedPaths.includes(location.pathname);

        if (isMobile && !bannerHidden && !isAuthenticated && isAllowedPath) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, [location.pathname, isAuthenticated]);

    const handleClose = (e: any) => {
        e.preventDefault();
        setIsVisible(false);
        localStorage.setItem('appBannerHidden', 'true');
    };

    const isIOS = () => {
        return (
            /(iPad|iPhone|iPod)/g.test(navigator.userAgent) ||
            (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        );
    };

    const handleOpenApp = (e: any) => {
        e.preventDefault();

        // Schéma pre otvorenie Quasar appky (musí byť nastavená v appke!)
        const appScheme = isIOS()
            ? "charge-app://"
            : "intent://#Intent;scheme=charge-app;package=eu.starbug.charge.sk;end";

        const storeUrl = isIOS()
            ? "https://apps.apple.com/sk/app/charge-sk/id6745960330"
            : "https://play.google.com/store/apps/details?id=eu.starbug.charge.sk";
            
        const start = Date.now();
        // 1. Pokus o otvorenie priamo aplikácie
        window.location.href = appScheme;

        // 2. Fallback do obchodu ak sa appka neotvorí
        setTimeout(() => {
            // Ak od kliknutia ubehlo viac ako 2500ms, znamená to, že 
            // prehliadač bol pravdepodobne pozastavený (otvárala sa appka)
            // Ak ubehlo presne ~2000ms a stránka je stále viditeľná, appka sa neotvorila.
            if (document.visibilityState === 'visible' && (Date.now() - start) < 2500) {
                window.location.href = storeUrl;
            }
        }, 2000);
    };

    if (!isVisible) return null;

    return (
        <div className={classes.appBanner}>
            <button className={classes.closeBtn} onClick={handleClose}>
                &times;
            </button>

            <img src={ChargeAppLogo} alt="App Icon" className={classes.appIcon} />

            <div className={classes.textContainer}>
                <strong>Charge.sk</strong>
                <span>{t('common.openInApp') || 'Prejsť do aplikácie'}</span>
            </div>

            <button className={classes.actionBtn} onClick={handleOpenApp}>
                {t('common.open') || 'OTVORIŤ'}
            </button>
        </div>
    );
};

export default AppBanner;